import { render } from "./S90419.vue?vue&type=template&id=7de6c8ae"
const script = {}
script.render = render

export default script